import { HttpErrorResponse, HttpInterceptorFn, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { DialogsService } from 'app/services/dialogs.service';
import { catchError, throwError } from 'rxjs';

export const BYPASS_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const dialogsService = inject(DialogsService);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (req.context.get(BYPASS_ERROR_INTERCEPTOR)) {
                return throwError(() => error);
            }
            const backendMessage =
                error.error?.message ||
                error.error?.detail ||
                error.message;

            let errorMessage = backendMessage || 'Algo no salió como esperábamos. Intentá de nuevo o contactá a soporte si el problema sigue.';

            switch (true) {
                // Errores de RED o CORS (servidor caído, sin internet)
                case error.status === 0:
                    errorMessage = 'Parece que no hay conexión. Revisá tu internet e intentá de nuevo.';
                    dialogsService.error(`${error.status}`, errorMessage);
                    break;

                // Bad Request
                case error.status === 400:
                    errorMessage = 'No pudimos procesar esto. Asegurate de que todos los datos estén completos.';
                    dialogsService.error(`${error.status}`, errorMessage);
                    break;

                // Unauthorized (Supertokens suele manejarlo, pero lo dejamos por las dudas)
                case error.status === 401:
                    // errorMessage = 'Sesión expirada o no autorizada.';
                    // dialogsService.snackBarError(errorMessage);
                    break;

                // Forbidden
                case error.status === 403:
                    errorMessage = 'Esta acción requiere permisos adicionales. Contactanos si creés que es un error.';
                    dialogsService.error(`${error.status}`, errorMessage);
                    break;

                // Not Found
                case error.status === 404:
                    errorMessage = 'Parece que esta página o registro no existe. Busquemos por otro lado.';
                    dialogsService.error(`${error.status}`, errorMessage);
                    break;

                // Conflict
                case error.status === 409:
                    errorMessage = 'Este registro ya existe en el sistema. Probá ingresando uno diferente.';
                    dialogsService.error(`${error.status}`, errorMessage);
                    break;

                // Unprocessable Entity (Validaciones de formulario desde backend)
                case error.status === 422:
                    errorMessage = 'Hay un pequeño error en los datos. Revisá los campos marcados para continuar.';
                    dialogsService.error(`${error.status}`, errorMessage);
                    break;

                // Errores de Servidor (5xx)
                case error.status >= 500:
                    errorMessage = 'Tuvimos un inconveniente técnico. Ya estamos trabajando para solucionarlo.';
                    dialogsService.error(`Error del Servidor (${error.status})`, errorMessage);
                    break;

                // Cualquier otro status no capturado explícitamente
                default:
                    dialogsService.snackBarError(errorMessage);
                    break;
            }

            return throwError(() => error);
        })
    );
};
